import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "@awsui/global-styles/index.css";
import styled from "styled-components";

import ListCampaigns from "./components/list-campaigns/ListCampaigns";
import CampaignDetails from "./components/describe-campaign/DescribeCampaign";
import CreateCampaign from "./components/create-campaign/CreateCampaign";
import SidebarView from "./components/SidebarView/SidebarView";
import ListEndpoints from "./components/list-endpoints/ListEndpoints";
import { AppLayout } from "@awsui/components-react";
import InitializeApp from "./components/shared/InitializeApp";
import { StoreProvider } from "easy-peasy";
import { store, useStoreState } from "./appstore";
import AuthenticateUser from "./components/shared/AuthenticateUser";
import "./App.css";
const logoImage = require("./static/logo.png").default;

const LogoImage = styled.img`
  height: 18px;
  margin-right: 1.5rem;
  margin-top: 5px;
`;
export const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path={["/", "/geo-campaigns"]} component={ListCampaigns} />
      <Route exact path="/geo-campaigns/new" component={CreateCampaign} />
      <Route path="/geo-campaigns/:jobName" component={CampaignDetails} />
      <Route path="/geo-endpoints" component={ListEndpoints} />
    </Switch>
  </BrowserRouter>
);

const AppLayoutContent = () => (
  <div className="awsui-grid">
    <div className="awsui-row">
      <Routes />
    </div>
  </div>
);

const Page = styled.div`
  padding-top: 40px;
`;
const NewNavbar = styled.div`
  display: fixed;
  position: fixed;
  height: 40px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  margin: 0;
  padding: 0 30px;
  background: #232f3e;

  background: var(--color-background-home-header-ScmmEP, #232f3e);
  font-family: "Amazon Ember", "Helvetica Neue", Roboto, Arial, sans-serif;
  color: white;
  .menu-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    padding: 0;
    list-style: none;
    .title {
      font-size: 1.75rem;
      font-weight: 500;
      padding-right: 2rem;
    }
  }
`;

const App = () => {
  return (
    <StoreProvider store={store}>
      <AppContent />
    </StoreProvider>
  );
};

const AppAuthenticated = () => {
  return (
    <Page>
      <div className="awsui">
        <InitializeApp />
        <NewNavbar id="app-header">
          <ul className="menu-list">
            <li>
              <LogoImage src={logoImage} />
            </li>
            <li className="title">Geospatial Data Services</li>
          </ul>
        </NewNavbar>
        <AppLayout
          content={<AppLayoutContent />}
          // breadcrumbs={<Breadcrumbs />}
          navigation={<SidebarView />}
          // tools={this.state.toolsContent}
          // toolsOpen={this.state.toolsOpen}
          toolsHide={true}
          // onToolsChange={({ detail }) => this.setState({ toolsOpen: detail.open })}
          // ariaLabels={appLayoutLabels}
          headerSelector="#app-header"
        ></AppLayout>
      </div>
    </Page>
  );
};
const AppUnauthenticated = () => {
  return (
    <Page>
      <div className="awsui">
        <InitializeApp />
        <NewNavbar id="app-header">
          <ul className="menu-list">
            <li>
              <LogoImage src={logoImage} />
            </li>
            <li className="title">Authenticating...</li>
          </ul>
        </NewNavbar>
        <AppLayout
          content={<div>Authenticating...</div>}
          headerSelector="#app-header"
        ></AppLayout>
      </div>
    </Page>
  );
};

const AppContent = () => {
  const auth = useStoreState((s) => s.internal.auth);
  if (!auth.isAuthenticated) {
    return (
      <>
        <AppUnauthenticated />
        <AuthenticateUser />
      </>
    );
  }

  return <AppAuthenticated />;
};
export default App;
